import axios from "axios";

const apiClient = axios.create({
    baseURL: "https://redoms-backend-dev.m-devsecops.com",
});

// Function to set up API client with token
export const setupApiClient = (token) => {
    apiClient.interceptors.request.use((config) => {
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    apiClient.interceptors.response.use(
        (response) => response,
        async (error) => {
            if (error.response.status === 401) {
                // Handle token expiration or unauthorized access
                console.error("Unauthorized access. Please log in again.");
            }
            return Promise.reject(error);
        }
    );
};

export default apiClient;